import React from 'react'
import Image from 'next/image'
import { cn } from '@/lib/utils'

interface LogomarkProps {
  className?: string
  /**
   * 'dark' uses the navy logomark (for light backgrounds)
   * 'light' uses the white logomark (for dark backgrounds)
   */
  variant?: 'dark' | 'light'
  size?: number
}

/**
 * The RELI Group logomark.
 * Use `variant="dark"` on light backgrounds, `variant="light"` on dark backgrounds.
 */
export function Logomark({
  className,
  variant = 'dark',
  size = 40,
}: LogomarkProps) {
  // Use the RELI Group 3D logo for both variants
  const src = '/logos/REli Group 3D logo.svg'

  return (
    <Image
      src={src}
      alt='RELI Group'
      width={size}
      height={size}
      className={cn('shrink-0', className)}
      priority
    />
  )
}

